module.exports = __webpack_public_path__ + "static/media/ico-question-mark.6c9ec97f.svg";